import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { permissoes } from '../../services/costantes';
import api from '../../services/api';
import { useHistory, useParams } from "react-router-dom";
import Erros from '../../components/Erro';

function EditarUsuario() {
    let history = useHistory();
    let { id } = useParams();
    const [usuario, setUsuario] = useState();

    const { register, handleSubmit, errors } = useForm();

    useEffect(() => {
        async function getUsuario() {
            await api.get('/Usuario/id/' + id).then(response => {
                setUsuario(response ? response.data : null);
            });
        }
        getUsuario();
    }, [id]);

    const onSubmit = async data => {
        window.scrollTo(0, 0);
        await api.put('/Usuario', data).then(response => {
            if (response) {
                history.push("/usuarios")
            }
        });
    };

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setUsuario(prevUsuario => ({ ...prevUsuario, [name]: value }));
    }

    return (
        <div className="container" style={{ marginTop: 20 }}>
            <div className="card">
                <div className="card-header">Usuários</div>
                <Erros />
                <div className="card-body">
                    <h5 className="card-title">Editar Usuário</h5>
                    <div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" defaultValue={id} name="id" ref={register} />
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Nome</label>
                                <div className="col-sm-10" style={{ display: "inline-flex" }}>
                                    <input type="text" className="form-control" name="nome" id="Nome" defaultValue={usuario ? usuario.nome : ""} ref={register({ required: true })} placeholder="Nome" />
                                    {errors.nome && <span className="text-danger ml-2">*</span>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">E-Mail</label>
                                <div className="col-sm-10" style={{ display: "inline-flex" }}>
                                    <input type="email" className="form-control" name="email" id="Email" defaultValue={usuario ? usuario.email : ""} ref={register({ required: true })} placeholder="E-Mail" />
                                    {errors.email && <span className="text-danger ml-2">*</span>}
                                </div>
                            </div>
                            <h5>Permissões</h5>
                            <div className="form-group row">
                                <div className="col-sm-2">Administrador</div>
                                <div className="col-sm-10">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="administrador" checked={usuario ? usuario.administrador : false} onChange={handleInputChange} ref={register} id="Administrador" />
                                        <label className="form-check-label">Ativo</label>
                                    </div>
                                </div>
                            </div>
                            {permissoes.map((p, index) => (
                                <fieldset key={index} className="form-group">
                                    <div className="row">
                                        <legend className="col-form-label col-sm-2 pt-0">{p.label}</legend>
                                        <div className="col-sm-10">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={p.name} ref={register} id={p.name + '1'} value="D" onChange={handleInputChange} checked={usuario ? (usuario[p.name] === 'D') : false} />
                                                <label className="form-check-label">Desativado</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={p.name} ref={register} id={p.name + '2'} value="V" onChange={handleInputChange} checked={usuario ? (usuario[p.name] === 'V') : false} />
                                                <label className="form-check-label">Visualizar</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={p.name} ref={register} id={p.name + '3'} value="M" onChange={handleInputChange} checked={usuario ? (usuario[p.name] === 'M') : false} />
                                                <label className="form-check-label">Inserir/Modificar</label>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            ))}
                            <div className="form-row">
                                <div className="col-md-12 pt-2">
                                    <div style={{ display: "inline-flex" }}>
                                        <button type="submit" className="btn btn-primary mb-2">Salvar</button>
                                        <Link className="btn btn-danger mx-sm-3 ml-2 mb-2" to="/usuarios">Cancelar</Link>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditarUsuario;